import { useEffect, useRef } from 'react';

export function useEventListener<K extends keyof WindowEventMap, T extends Window | HTMLElement>(
    element: T,
    eventName: T extends Window ? K : string,
    handler: (e: Event) => void,
) {
    const savedHandler = useRef<typeof handler>(handler);

    useEffect(() => {
        savedHandler.current = handler;
    }, [handler]);

    useEffect(() => {
        const eventListener: EventListenerOrEventListenerObject = (e) => savedHandler.current(e);

        element.addEventListener(eventName, eventListener);

        return () => {
            element.removeEventListener(eventName, eventListener);
        };
    }, [eventName, element]);
}
